import { HTTP } from "../Http/Http"

export const UsuarioRepository = {
    Auntenticar: async (body : any) => {
        return HTTP.POST('Login/Autenticar',body,{})
    },
    Listar: async () => {
        return HTTP.GET('Usuario/Listar')
    }
}